import { useState } from "react";
import { ChevronDown, HelpCircle } from "lucide-react";
import ScToolkitBack from "../../components/sc/ScToolkitBack";

const FAQS = [
  {
    q: "How long does installation take after the customer accepts the quote?",
    a: "Typically 2-3 weeks — this covers technical site survey, material dispatch, installation and net-metering coordination with the DISCOM.",
  },
  {
    q: "When do I get paid my referral commission?",
    a: "Your payout moves to 'Processing' once the installation is completed and the final invoice is settled, then to 'Paid' once the transfer is made to your UPI ID. Track live status under Payouts.",
  },
  {
    q: "Does the customer need to pay anything upfront?",
    a: "No advance is required to submit a lead. Payment terms (advance / milestone-based) are shared by our sales team once the quotation is finalised with the customer.",
  },
  {
    q: "What if the customer's roof isn't suitable (shaded, weak structure, etc.)?",
    a: "Our technical team confirms suitability during the free site survey. If the roof isn't viable, the lead is marked accordingly and you'll see the reason on the lead detail.",
  },
  {
    q: "Is the government subsidy guaranteed?",
    a: "Subsidy under PM Surya Ghar Yojana is disbursed by the central government after commissioning and portal approval — timelines depend on the government portal, typically 4-8 weeks post-installation.",
  },
  {
    q: "Can I refer a lead outside my state?",
    a: "Yes — we service leads pan-India, subject to serviceability checks by PIN code. If an area isn't serviceable yet, the lead will be flagged 'Non Serviceable Area'.",
  },
  {
    q: "What warranty does the customer get?",
    a: "Solar panels typically carry a 25-year performance warranty and inverters 5-10 years (varies by brand). Comprehensive warranty terms are shared in the final quotation.",
  },
  {
    q: "How do I track a lead's progress?",
    a: "Open My Leads — every referred lead shows its current phase (Diligence → Solution → Regulatory → Install → Subsidy) and installation status in real time.",
  },
];

function FaqItem({ item, open, onToggle }) {
  return (
    <div className="bg-white border border-slate-200 rounded-2xl overflow-hidden shadow-[0_2px_8px_rgba(15,23,42,0.04)]" data-testid="sc-faq-item">
      <button
        type="button"
        onClick={onToggle}
        className="w-full flex items-center justify-between gap-3 px-4 py-3.5 text-left"
        data-testid="sc-faq-toggle"
      >
        <span className="text-sm font-semibold text-slate-900">{item.q}</span>
        <ChevronDown className={"w-4 h-4 text-slate-400 flex-shrink-0 transition-transform " + (open ? "rotate-180" : "")} />
      </button>
      {open && (
        <div className="px-4 pb-4 text-[12.5px] text-slate-600 leading-relaxed border-t border-slate-100 pt-3">
          {item.a}
        </div>
      )}
    </div>
  );
}

export default function ScFaq() {
  const [openIdx, setOpenIdx] = useState(0);

  return (
    <div data-testid="sc-faq" className="pb-6">
      <ScToolkitBack />
      <div className="font-mono text-[9px] uppercase tracking-[0.25em] text-slate-500">Toolkit</div>
      <h1 className="text-2xl font-bold tracking-tight mt-1 text-slate-900 flex items-center gap-2">
        <HelpCircle className="w-5 h-5 text-[#D97706]" /> Common questions.
      </h1>
      <p className="text-sm text-slate-500 mt-1.5">Fast answers for the questions customers ask most often in the field.</p>

      <div className="mt-5 space-y-2.5" data-testid="sc-faq-list">
        {FAQS.map((item, i) => (
          <FaqItem key={i} item={item} open={openIdx === i} onToggle={() => setOpenIdx(openIdx === i ? -1 : i)} />
        ))}
      </div>
    </div>
  );
}
